(() => {
  const SECTION_SELECTOR = '.oddit-footer-main';
  const ACCORDION_SELECTOR = '[data-accordion]';
  const HEADING_SELECTOR = '.oddit-footer-main__nav-heading';
  const DESKTOP_MQ = '(min-width: 990px)';

  function initSection(section) {
    const accordions = section.querySelectorAll(ACCORDION_SELECTOR);
    const mq = window.matchMedia(DESKTOP_MQ);

    function handleToggle(e) {
      const btn = e.target.closest(HEADING_SELECTOR);
      if (!btn) return;
      if (mq.matches) return; // No accordion on desktop

      const column = btn.closest(ACCORDION_SELECTOR);
      if (!column) return;

      const isOpen = column.classList.contains('is-open');

      // Close all other accordions
      for (const acc of accordions) {
        acc.classList.remove('is-open');
        const accBtn = acc.querySelector(HEADING_SELECTOR);
        if (accBtn) accBtn.setAttribute('aria-expanded', 'false');
      }

      // Toggle current
      if (!isOpen) {
        column.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    }

    function handleBreakpointChange() {
      if (mq.matches) {
        // Desktop: open all, remove accordion behavior
        for (const acc of accordions) {
          acc.classList.remove('is-open');
          const accBtn = acc.querySelector(HEADING_SELECTOR);
          if (accBtn) accBtn.setAttribute('aria-expanded', 'false');
        }
      } else {
        // Mobile: close all, then open the first
        accordions.forEach((acc, i) => {
          const accBtn = acc.querySelector(HEADING_SELECTOR);
          if (i === 0) {
            acc.classList.add('is-open');
            if (accBtn) accBtn.setAttribute('aria-expanded', 'true');
          } else {
            acc.classList.remove('is-open');
            if (accBtn) accBtn.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }

    section.addEventListener('click', handleToggle);
    mq.addEventListener('change', handleBreakpointChange);

    // Init state
    handleBreakpointChange();
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();